import {v3} from "oc-threejs/short3";
import RaumO3 from "../object3d/Raum";

export default class Raum {

    // persistent (UserLayer) ------------------------------------------

    // transient (CompiledLayer) ---------------------------------------

    parent: Object;
    object3d: ?THREE.Object3D;
    position = new THREE.Vector3();
    quaternion = new THREE.Quaternion();
    parent3d: ?THREE.Object3D;
    size = v3();
    box = new THREE.Box3();
    matrix = new THREE.Matrix4();

    constructor(parent) {
        this.parent = parent;
    }

    get arrangement() {
        return this.parent;
    }

    compile() {
        APP.model.lazyCreateObject3d(this, () => {
            const o3 = new RaumO3(this);
            this.arrangement.object3d.add(o3);
            this.arrangement.object3d.raum = o3;
            return o3;
        });
        const hoehe = APP.settings.getMinValue('raum_hoehe');
        const tiefe = APP.settings.getMinValue('raum_tiefe');
        const breite = 2 * APP.settings.getMinValue('raum_breite_raster');
        this.size.set(breite,hoehe,tiefe);
        this.box.setFromCenterAndSize(v3(0,0.5,0.5).multiply(this.size),this.size);
    }

    iterate(iterator) {
        iterator(this);
    }

}
